import {
  OFFER_TYPE_HOTEL,
  OFFER_TYPE_ALWAYS_ON,
  OFFER_TYPE_BED_BANK,
  OFFER_TYPE_BUNDLE_AND_SAVE,
} from 'constants/offer'

export const TOP_N = 3
export const HOTEL_OFFER_TYPES: Array<App.OfferListOfferType> = [
  OFFER_TYPE_HOTEL,
  OFFER_TYPE_ALWAYS_ON,
  OFFER_TYPE_BED_BANK,
  OFFER_TYPE_BUNDLE_AND_SAVE,
]

export function hasTopOffersChanged(idsA: Array<string>, idsB: Array<string>): boolean {
  const topA = idsA.slice(0, TOP_N)
  const topB = idsB.slice(0, TOP_N)

  if (topA.length === 0 || topB.length === 0) return false
  if (topA.length !== topB.length) return true

  return topA.some((id, index) => id !== topB[index])
}
